import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Typography } from '@mui/material';
import { alpha, useTheme } from '@mui/material/styles';
import { getIconByName } from '../../../utils/iconMap';
import { resolvePublicUrl } from '../../../utils/publicUrl';
import { portalContentMaxWidthSx, portalPageHorizontalPaddingSx } from '../../../theme/portalLayout';
const WhyChooseSection = ({ heading, subheading, items = [], image, imageAlt = '', }) => {
    const theme = useTheme();
    const imageSrc = image ? resolvePublicUrl(image) ?? image : '';
    return (_jsx(Box, { id: "why-choose", component: "section", sx: {
            bgcolor: '#ffffff',
            py: { xs: 5, md: 7 },
            ...portalPageHorizontalPaddingSx,
            scrollMarginTop: 16,
        }, children: _jsxs(Box, { sx: portalContentMaxWidthSx, children: [_jsxs(Box, { sx: { textAlign: 'center', mb: { xs: 4, md: 5 } }, children: [_jsx(Typography, { variant: "h3", component: "h2", sx: {
                                fontWeight: 800,
                                color: 'primary.dark',
                                fontSize: { xs: '1.65rem', md: '2.125rem' },
                                mb: 1.5,
                            }, children: heading }), subheading && (_jsx(Typography, { variant: "body1", sx: {
                                color: 'text.secondary',
                                maxWidth: 720,
                                mx: 'auto',
                                lineHeight: 1.65,
                            }, children: subheading }))] }), _jsxs(Box, { sx: {
                        display: 'grid',
                        gridTemplateColumns: { xs: '1fr', lg: '1fr minmax(280px, 38%)' },
                        gap: { xs: 3, md: 4 },
                        alignItems: 'stretch',
                    }, children: [_jsx(Box, { sx: {
                                display: 'grid',
                                gridTemplateColumns: { xs: '1fr', sm: 'repeat(2, 1fr)' },
                                gridTemplateRows: { lg: 'repeat(3, minmax(0, auto))' },
                                gap: { xs: 2, md: 2.25 },
                                order: { xs: 2, lg: 1 },
                            }, children: items.map((item, i) => {
                                const Icon = getIconByName(item.icon);
                                return (_jsxs(Box, { sx: {
                                        bgcolor: '#fff',
                                        borderRadius: 2,
                                        border: '1px solid',
                                        borderColor: alpha(theme.palette.primary.main, 0.12),
                                        p: 2.25,
                                        minHeight: 0,
                                        display: 'flex',
                                        flexDirection: 'column',
                                        boxShadow: '0 1px 4px rgba(0,40,85,0.04)',
                                        transition: 'box-shadow 0.2s ease, border-color 0.2s ease',
                                        '&:hover': {
                                            borderColor: alpha(theme.palette.primary.main, 0.22),
                                            boxShadow: `0 8px 24px ${alpha(theme.palette.primary.main, 0.08)}`,
                                        },
                                    }, children: [_jsx(Box, { sx: {
                                                width: 44,
                                                height: 44,
                                                borderRadius: '50%',
                                                bgcolor: alpha(theme.palette.primary.main, 0.1),
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                mb: 1.5,
                                            }, children: _jsx(Icon, { sx: { fontSize: 22, color: 'primary.main' } }) }), _jsx(Typography, { variant: "subtitle1", sx: { fontWeight: 700, color: 'primary.dark', mb: 0.75 }, children: item.title }), _jsx(Typography, { variant: "body2", sx: { color: 'text.secondary', lineHeight: 1.55 }, children: item.description })] }, i));
                            }) }), _jsx(Box, { sx: {
                                order: { xs: 1, lg: 2 },
                                borderRadius: 2,
                                overflow: 'hidden',
                                minHeight: { xs: 280, sm: 360 },
                                height: { lg: 'auto' },
                                alignSelf: 'stretch',
                                display: 'flex',
                                boxShadow: '0 12px 40px rgba(0,40,85,0.12)',
                            }, children: _jsx(Box, { component: "img", loading: "lazy", decoding: "async", src: imageSrc, alt: imageAlt, sx: {
                                    width: '100%',
                                    height: '100%',
                                    objectFit: 'cover',
                                    objectPosition: '44% center',
                                    transform: 'scale(1.38)',
                                    transformOrigin: 'center center',
                                    display: 'block',
                                } }) })] })] }) }));
};
export default WhyChooseSection;
